import React from 'react';
import { Checkbox, FormControlLabel } from 'lib/cortiUI';
import { TEST_IDS } from './utils';
export const CheckboxField = ({ onChange, value, label, rules, name }) => {
    return (React.createElement(FormControlLabel, { checked: value, "data-cy": TEST_IDS.checkbox, label: label, onChange: (_e, checked) => onChange(checked), control: React.createElement(Checkbox, { inputProps: { 'data-cy': `${TEST_IDS.checkbox}-${name}` }, required: Boolean(rules === null || rules === void 0 ? void 0 : rules.required) }) }));
};
